import React, { FunctionComponent } from 'react';
import classNames from 'classnames';
import ProductComponent, {
  TParentComponentProps,
} from '@views/components/common/ParentComponent';

export type TListInlineItemProps = TParentComponentProps & {
  active?: boolean;
};

export const ListInlineItem: FunctionComponent<TListInlineItemProps> = ({
  active,
  className,
  ...otherProps
}) => {
  const cx = classNames({
    'list-inline__item--active': active,
    [className]: !!className,
  });

  return <ProductComponent className={cx} {...otherProps} />;
};
ListInlineItem.defaultProps = {
  as: 'li',
  defaultClassName: 'list-inline-item list-inline__item',
};

export default ListInlineItem;
